<template>
  <BaseLandingWithoutTabs
    :faq-id="14">
    <template #header>
      <div>{{$t('renew_header_home')}}</div>
    </template>
  </BaseLandingWithoutTabs>
</template>

<script>
import BaseLandingWithoutTabs from '@/components/BaseLandingWithoutTabs.vue'
export default {
  name: 'LandingHome',
  components: {
    BaseLandingWithoutTabs
  }
}
</script>
